import { Grid } from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { Tab } from "react-bootstrap";
import { useStylesSetting } from "../helpers/settingEvtOption";
import ContactForm from "./components/ContactForm";
import ContentSocial from "./components/ContentSocial";

export default function ContactSetting() {
    const useClass = useStylesSetting();

    // component state
    const [isTabs, setIsTabs] = useState("contact");

    // change tab
    const handleChangeTabs = useCallback(
        tab => {
            setIsTabs(tab);
        },
        [setIsTabs],
    );

    return (
        <Grid container spacing={0}>
            <Grid item xs={12} className="mb-3">
                <h1 className="t-text-primary">Contact Setting</h1>
            </Grid>
            {/* Tabs */}
            <Grid item xs={12}>
                <Grid container spacing={1} className="justify-content-lg-start">
                    <Grid item xs={12}>
                        <div className="row">
                            <div className="col-12">
                                <div
                                    className="d-flex align-items-center"
                                    style={{ overflowX: "auto", overflowY: "hidden" }}>
                                    <div className="col-4 col-sm-3 col-lg-2 px-0">
                                        <div
                                            className={`${useClass.boxlistRoom} ${
                                                isTabs === "contact" ? "active" : ""
                                            }`}
                                            onClick={() => handleChangeTabs("contact")}>
                                            <p className="text-typo">{`Contact`}</p>
                                        </div>
                                    </div>
                                    <div className="col-4 col-sm-3 col-lg-2 px-0">
                                        <div
                                            className={`${useClass.boxlistRoom} ${isTabs === "social" ? "active" : ""}`}
                                            onClick={() => handleChangeTabs("social")}>
                                            <p className="text-typo">{`Social`}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Grid>
            {/* content */}
            <Grid item xs={12}>
                <Tab.Container activeKey={isTabs}>
                    <Tab.Content>
                        <Tab.Pane eventKey={"contact"} className="p-5">
                            <ContactForm />
                        </Tab.Pane>
                        <Tab.Pane eventKey={"social"} className="p-5">
                            <ContentSocial />
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>
            </Grid>
        </Grid>
    );
}
